import { Component, computed, inject } from '@angular/core';
import { PresenceService, PresenceEntry } from '@luzula/luzula-lib';

/**
 * Schwache Praesenz-Anzeige in der Navbar: zeigt, wer parallel im
 * gleichen Projekt arbeitet (z.B. ein Kollege in QGIS via dem
 * luzula-qgis-plugin). Kein Lock — nur sozialer Hinweis.
 *
 * Datenfluss: ProjectService startet/stoppt PresenceService beim
 * Projekt-Wechsel; wir lesen hier `others()`, das die eigene Sitzung
 * (ueber sessionId) bereits ausfiltert.
 *
 * Sichtbar nur, wenn andere Sitzungen im Projekt aktiv sind. Tooltip
 * listet sie zeilenweise mit Name, Source und Alter ("vor 2 Min").
 */
@Component({
	standalone: false,
	selector: 'bp-presence-badge',
	templateUrl: './presence-badge.component.html',
	styleUrls: ['./presence-badge.component.scss'],
})
export class PresenceBadgeComponent {
	private presence = inject(PresenceService);

	readonly others = this.presence.others;

	readonly count = computed(() => this.others().length);

	displayName(p: PresenceEntry): string {
		if (p.firstName && p.lastName) return `${p.firstName} ${p.lastName}`;
		if (p.firstName) return p.firstName;
		if (p.lastName) return p.lastName;
		return p.username || p.userId || 'unbekannt';
	}

	sourceLabel(s: string): string {
		switch (s) {
			case 'qgis': return 'QGIS';
			case 'bpweb': return 'bpweb';
			case 'forsteinrichtung': return 'Forsteinrichtung';
			case 'weisergatter': return 'Weisergatter';
			default: return s;
		}
	}

	formatAge(seconds: number): string {
		if (seconds < 60) return 'gerade aktiv';
		if (seconds < 3600) return `vor ${Math.round(seconds / 60)} Min`;
		return `vor ${Math.round(seconds / 3600)} h`;
	}
}
